import { React, useEffect, useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import AxiosApi from "../Helper/axios.api";
import { toast } from "react-toastify";
import helper from "../Helper/Helper";
import { Input } from "reactstrap";
import VoiceRecorder from "../Components/Frontend/VoiceRecorder";
import Uplaod_icon from "../assets/images/upload-icon.svg";

function CreateAnimation( props ) {
  const auth = useSelector((state) => state.auth);
  const [isGenerating, setIsGenerating] = useState(false);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(0);
  const [errormessage, setErrormessage] = useState("");
  const [facekey, setFacekey] = useState(0);

  // Voice recording states
  const [audioBlob, setAudioBlob] = useState(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const [useVoiceMorphing, setUseVoiceMorphing] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [state, setState] = useState({
    template_id: "",
    img_url: "",
    thumb: "",
    video: "",
    user_id: auth.userDeatils.user_id,
    face_postions: [],
    image_size_face: [],
    face_thumbnails: [],
    title: "",
    use_voice_morphing: false,
    cropped_source_url: "",
    resized_source_url: "",
  });
  const {
    template_id,
    face_postions,
    title,
    image_size_face,
    face_thumbnails,
    img_url,
    thumb,
    video,
    user_id,
    use_voice_morphing,
    cropped_source_url,
    resized_source_url,
  } = state;
  const [imageBox, setImageBox] = useState(null);
  const [imageBoxHeight, setImageBoxHeight] = useState("");
  const [imageBoxWidth, setImageBoxWidth] = useState("");

  useEffect(() => {
    // use timeout to let the element mount and image load
    const updateDimensions = () => {
      if (imageBox && imageBox.offsetWidth > 0 && imageBox.offsetHeight > 0) {
        setImageBoxWidth(imageBox.offsetWidth);
        setImageBoxHeight(imageBox.offsetHeight);
      }
    };

    if (imageBox) {
      // Check if image is already loaded
      if (imageBox.complete && imageBox.naturalHeight !== 0) {
        updateDimensions();
      } else {
        // Wait for image to load
        imageBox.onload = updateDimensions;
      }
    }

    // Add resize listener for responsive updates
    const handleResize = () => {
      setTimeout(updateDimensions, 100);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [imageBox, img_url]);

  const resetModal = () => {
    setFacekey(0);
    setErrormessage("");
    resetVoiceRecording();
    setShowConfirmModal(false);
    setState((state) => ({
      ...state,
      img_url: "",
      thumb: "",
      video: "",
      face_postions: [],
      image_size_face: [],
      face_thumbnails: [],
      title: "",
      template_id: "",
      use_voice_morphing: false,
      cropped_source_url: "",
      resized_source_url: "",
    }));
    setStep(0);
    setIsGenerating(false);
    setUseVoiceMorphing(false);
  };

  const resetVoiceRecording = () => {
    setAudioBlob(null);
    setAudioUrl(null);
  };

  const hideModal = () => {
    resetModal();
    props.setModalShow(false);
  };

  const handleModalClose = () => {
    if (step === 4 && title.trim()) {
      // Show custom confirmation modal if user has made progress
      setShowConfirmModal(true);
    } else {
      hideModal();
    }
  };

  const handleConfirmDiscard = () => {
    setShowConfirmModal(false);
    hideModal();
  };

  const handleConfirmSave = () => {
    setShowConfirmModal(false);
    handleAnimationSave();
  };

  const handleConfirmCancel = () => {
    setShowConfirmModal(false);
  };

  const changefile = async (e) => {
    setErrormessage("");
    const file = e.target.files[0];

    const allowed_type = ["image/jpeg", "image/jpg", "image/png"];
    if (allowed_type.indexOf(file.type) === -1) {
      setErrormessage("File type not suppoted");
      return false;
    }
    if (file.size > 10000000) {
      setErrormessage("File Size limit 10MB");
      return false;
    }

    setLoading(true);
    let data = new FormData();
    data.append("file", file);
    data.append("user_id", user_id);
    data.append("template_id", template_id);
    AxiosApi.withToken(auth.accessToken, "templates/create", "post", data)
      .then((res) => {
        if (res.status) {
          const min = 1;
          const max = 100;
          let random = min + Math.random() * (max - min);
          setState((state) => ({
            ...state,
            template_id: res.data.id,
            title: res.data.name,
            img_url: helper.ApiBaseUrl + res.data.img + "?" + random,
          }));
        } else {
          setErrormessage(res.message);
        }
      })
      .catch((errors_res) => {
        setErrormessage(errors_res.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const findFaces = () => {
    setErrormessage("");
    setLoading(true);
    let data = {};
    data.template_id = template_id;
    data.user_id = auth.userDeatils.user_id;
    AxiosApi.withToken(auth.accessToken, "templates/find_faces", "post", data)
      .then((res) => {
        if (res.status) {
          if (!res.data.faces.length) {
            setErrormessage("Face not found.");
          } else if (res.data.size[0] < 120 || res.data.size[1] < 120) {
            setErrormessage("Please Upload min 120px image size.");
          } else {
            setState((state) => ({
              ...state,
              face_postions: res.data.faces,
              image_size_face: res.data.size,
              face_thumbnails: res.data.thumbnails,
            }));
            setStep(1);
          }
        } else {
          setErrormessage(res.message);
        }
      })
      .catch((errors_res) => {
        setErrormessage(errors_res.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const faceBox = (index, item) => {
    if (!imageBox || !imageBoxHeight || !imageBoxWidth) return null;

    let o_width = image_size_face[0];
    let o_height = image_size_face[1];

    // Calculate scale based on the actual image display size vs original size
    const scaleX = imageBox.offsetWidth / o_width;
    const scaleY = imageBox.offsetHeight / o_height;

    // Use the smaller scale to maintain aspect ratio (object-fit: contain behavior)
    const scale = Math.min(scaleX, scaleY);

    // Calculate the actual displayed dimensions of the image
    const displayedWidth = o_width * scale;
    const displayedHeight = o_height * scale;

    // Since img_overlay has display: inline-block and the image determines its size,
    // and face boxes are now inside img_overlay, we can position them directly
    // relative to the image without additional offsets
    const new_left = item[0] * scale;
    const new_top = item[1] * scale;
    const new_right = item[2] * scale;
    const new_bottom = item[3] * scale;

    return (
      <div
        className={
          facekey === index ? "face_detection_active" : "face_detection"
        }
        onClick={(e) => {
          e.stopPropagation();
          setFacekey(index);
        }}
        key={template_id + face_thumbnails[index]}
        style={{
          position: "absolute",
          cursor: "pointer",
          left: new_left,
          top: new_top,
          width: new_right - new_left,
          height: new_bottom - new_top,
          backgroundImage: `url(${helper.ApiBaseUrl}${face_thumbnails[index]})`,
          backgroundSize: "cover",
          borderRadius: "4px",
          pointerEvents: "all",
          zIndex: 100,
        }}
      ></div>
    );
  };

  const cropTemplate = () => {
    setErrormessage("");
    setLoading(true);

    let data = new FormData();
    data.append("user_id", auth.userDeatils.user_id);
    data.append("template_id", template_id);
    data.append("face_box", face_postions[facekey]);

    AxiosApi.withToken(
      auth.accessToken,
      "templates/crop",
      "post",
      data
    )
    .then((res) => {
      if (!res.status) throw Error(res.message);
      setState((state) => ({
        ...state,
        template_id: res.data.id,
        title: res.data.name,
        cropped_source_url: helper.ApiBaseUrl + res.data.cropped_source_url,
        resized_source_url: helper.ApiBaseUrl + res.data.resized_source_url,
      }));
      setStep(2); // Go to image selection step
      return res.data.id;
    })
    .catch((errors_res) => {
      setErrormessage(errors_res.message);
    })
    .finally(() => {
      setLoading(false);
    });
  };

  const selectImageType = (imageType) => {
    setErrormessage("");
    setLoading(true);

    let data = {};
    data.user_id = auth.userDeatils.user_id;
    data.template_id = template_id;
    data.image_type = imageType; // 'cropped' or 'resized'

    AxiosApi.withToken(
      auth.accessToken,
      "templates/select_image_type",
      "post",
      data
    )
    .then((res) => {
      if (!res.status) throw Error(res.message);
      setState((state) => ({
        ...state,
        thumb: res.data.thumb,
        video: res.data.video,
      }));
      setStep(3); // Go to voice recording step
      return res.data.id;
    })
    .catch((errors_res) => {
      setErrormessage(errors_res.message);
    })
    .finally(() => {
      setLoading(false);
    });
  };

  // Callback functions for VoiceRecorder component
  const handleVoiceRecordingComplete = (blob, url) => {
    setAudioBlob(blob);
    setAudioUrl(url);
  };

  const handleVoiceRecordingError = (error) => {
    setErrormessage(error);
  };

  const uploadVoiceFile = async () => {
    if (!audioBlob) return null;

    setLoading(true);
    setErrormessage(""); // Clear any previous errors

    try {
      const formData = new FormData();
      formData.append('voice_file', audioBlob, 'voice_recording.wav');
      formData.append('user_id', user_id);
      formData.append('template_id', template_id);

      const res = await AxiosApi.withToken(
        auth.accessToken,
        "templates/upload_voice",
        "post",
        formData,
      );

      if (res.status) {
        setState(state => ({
          ...state,
          use_voice_morphing: true,
        }));
        return true; // Success
      } else {
        setErrormessage(res.message || "Voice upload failed");
        return false; // Failure
      }
    } catch (error) {
      setErrormessage(error.message || "Voice upload failed");
      return false; // Failure
    } finally {
      setLoading(false);
    }
  };

  const proceedToFinalStep = async () => {
    if (useVoiceMorphing && audioBlob != null) {
      const uploadSuccess = await uploadVoiceFile();
      if (!uploadSuccess) {
        // Stop if there was an error uploading voice
        return;
      }
    }

    // Skip preview generation and go directly to save/discard step
    setStep(4);
  };

  const handleAnimationSave = async () => {
    let data = {};
    data.user_id = auth.userDeatils.user_id;
    data.template_id = template_id;
    data.name = title;

    if (useVoiceMorphing && audioBlob != null) {
      data.enable_morphing = true;
    }

    setLoading(true);

    try {
      // First save the animation
      const saveRes = await AxiosApi.withToken(auth.accessToken, "templates/edit", "post", data);
      if (saveRes.status) {
        // Show success message immediately
        toast.success(saveRes.message + " Preview generation will complete in a few minutes.", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        // Close modal and update dashboard immediately
        props.setIsUpdate(!props.isUpdate);
        hideModal();

        // Trigger preview creation in the background (fire and forget)
        AxiosApi.withToken(
          auth.accessToken,
          "templates/create_preview",
          "post",
          {template_id: template_id, user_id: auth.userDeatils.user_id},
        ).catch((previewError) => {
          console.warn("Preview creation failed:", previewError);
        });
      } else {
        toast.error(saveRes.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (errors_res) {
      toast.error(errors_res.message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAnimationDiscard = () => {
    hideModal();
  };

  const setTitle = (newTitle) => {
    setState(prevState => ({
      ...prevState,
      title: newTitle
    }));
  };

  return (
    <Modal
      show={props.modalShow}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      className="createanimation-modal"
      centered
      onHide={handleModalClose}
      style={{ zIndex: "999999" }}
      backdrop="static"
      dialogClassName="custom-modal-dialog"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <div id={loading ? "pageLoader" : ""} />
          {step === 4 ? (
            <div className="d-flex align-items-center w-100" style={{ gap: "20px" }}>
              <h5 className="modal-title mb-0" style={{ minWidth: "150px" }}>Save Animation</h5>
            </div>
          ) : (
            <div className="d-flex align-items-center w-100" style={{ gap: "20px" }}>
              <h5 className="modal-title mb-0" style={{ minWidth: "150px" }}>Create Animation</h5>
            </div>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {step === 4 ? (
          <div className="final-step-container">
            <div className="text-center mb-4">
              <i className="fa fa-check-circle text-success" style={{ fontSize: "48px" }}></i>
              <h4 className="mt-3 mb-2">Animation Ready!</h4>
              <p className="text-muted">
                Your uploads have been processed and are ready to be saved.
                {useVoiceMorphing && " Voice morphing has been applied."}
                <br />
                Animation previews will be generated after saving and will be ready in a few minutes.
              </p>
            </div>

            <div className="animation-details-card p-4 border rounded bg-light">
              <div className="row align-items-center">
                <div className="col-md-3 text-center">
                  {thumb && (
                    <img
                      src={helper.ApiBaseUrl + thumb}
                      alt="Animation thumbnail"
                      className="img-fluid rounded"
                      style={{ maxWidth: "120px", maxHeight: "120px" }}
                    />
                  )}
                </div>
                <div className="col-md-9">
                  <div className="animation-name-input">
                    <label htmlFor="animation-title" className="form-label">
                      <i className="fa fa-tag me-1"></i>
                      Animation Name
                    </label>
                    <Input
                      type="text"
                      id="animation-title"
                      name="title"
                      placeholder="Enter animation name"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      className="form-control"
                      style={{ fontSize: "14px" }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="final-step-actions mt-4 text-center">
              <div className="d-flex justify-content-center" style={{ gap: "15px" }}>
                <button
                  type="button"
                  className="btn btn-warning text-white"
                  onClick={handleAnimationDiscard}
                  style={{ minWidth: "120px" }}
                >
                  <i className="fa fa-trash me-1"></i>
                  Discard
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleAnimationSave}
                  disabled={!title.trim()}
                  style={{ minWidth: "120px" }}
                >
                  <i className="fa fa-save me-1"></i>
                  Save Animation
                </button>
              </div>
              <small className="text-muted mt-2 d-block">
                You can view and edit the animation previews after saving.
              </small>
            </div>
          </div>
        ) : (
          <div className={`uploading-block d-flex flex-wrap flex-sm-nowrap align-items-center`} style={{gap:"30px"}}>
            { (step == 0 && (template_id === "" || img_url === "") ) ? ( // Upload image
            <div className="uploading-block-left" style={{flex: "1", maxWidth: "100%"}}>
              <div className="upload-section">
                <div className="upload-header mb-3 text-center">
                  <h5 className="mb-2">Upload Your Image</h5>
                  <p className="text-muted small mb-0">
                    Choose a clear photo with a visible face
                  </p>
                </div>
                <div className="input-group upload-input-wrapper">
                  <input
                    type="file"
                    className="form-control"
                    id="chooseImage"
                    accept="image/png, image/jpg, image/jpeg"
                    name="image"
                    onChange={(e) => changefile(e)}
                  />
                  <label className="input-group-text upload-label">
                    <div className="upload-content">
                      <span className="upload-icon">
                        <img src={Uplaod_icon} alt="Upload" />
                      </span>
                      <span className="input-text">
                        Choose an image or drag it here
                      </span>
                      <span className="input-text1">
                        The image must contain a frontal face which is clearly visible
                      </span>
                      <div className="upload-specs">
                        <small className="text-muted">
                          <i className="fa fa-check me-1"></i>
                          Supported: JPG, PNG • Max size: 10MB
                        </small>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
              <div className="face-selection-info mt-3">
                <div className="info-card p-3 bg-light rounded">
                  <div className="d-flex align-items-center">
                    <i className="fa fa-info-circle text-primary me-2"></i>
                    <div>
                      <small>
                        <strong>Pro Tip </strong>
                        Use our enhancement tool to improve low quality images.
                      </small>
                      <br />
                      <Link to="/edit">Click here to go to the enhancement tool</Link>
                    </div>
                  </div>
                </div>
              </div>
              {errormessage != "" ? (
                <div className="alert alert-danger alert-dismissible mt-3">
                  <span
                    className="close"
                    onClick={() => setErrormessage("")}
                  >
                    &times;
                  </span>
                  {errormessage}
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (step == 0) ? ( // View image
            <div className="selectface-block-left" style={{flex: "1", maxWidth: "calc(100% - 350px)"}}>
              <div className="image-preview-header mb-3">
                <h5 className="mb-2">Review Your Image</h5>
                <p className="text-muted small mb-0">
                  Make sure this image looks good and contains a clear face
                </p>
              </div>
              <div className="image-preview-container">
                <div className="select-face-box">
                  <img
                    key={img_url}
                    src={img_url}
                    alt="Upload"
                    className="preview-image-display"
                    ref={(el) => {setImageBox(el)}}
                    onLoad={() => {
                      // Trigger re-calculation when image loads
                      if (imageBox) {
                        setImageBoxWidth(imageBox.offsetWidth);
                        setImageBoxHeight(imageBox.offsetHeight);
                      }
                    }}
                  />
                </div>
              </div>
              <div className="modal-left-actions">
                <div className="action-buttons-container">
                  <button
                    type="button"
                    className="btn btn-secondary btn-prev"
                    onClick={() => resetModal()}
                  >
                    <i className="fa fa-arrow-left me-1"></i>
                    Back
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-next"
                    onClick={() => findFaces()}
                  >
                    Next
                    <i className="fa fa-arrow-right ms-1"></i>
                  </button>
                </div>
                {errormessage != "" && (
                  <div className="alert alert-danger alert-dismissible mt-3">
                    <span
                      className="close"
                      onClick={() => setErrormessage("")}
                    >
                      &times;
                    </span>
                    {errormessage}
                  </div>
                )}
              </div>
            </div>
          ) : (step == 1) ? ( // Select face
            <div className="selectface-block-left" style={{flex: "1", maxWidth: "calc(100% - 350px)"}}>
              <div className="face-selection-header mb-3">
                <h5 className="mb-2">Select a Face</h5>
                {face_postions.length > 1 && (
                  <p className="text-muted small mb-0">
                    Click on the face you want to animate ({face_postions.length} faces detected)
                  </p>
                )}
              </div>
              <div className="select-face-container">
                <div className="select-face-box">
                  <div className="face-image-wrapper">
                    <div className="img_overlay" style={{ filter: 'none', opacity: 1 }}>
                      <img
                        src={img_url}
                        key={img_url}
                        alt="Upload"
                        className="face-selection-image"
                        style={{ filter: 'brightness(1) contrast(1)', opacity: 1 }}
                        ref={(el) => {setImageBox(el)}}
                        onLoad={() => {
                          // Trigger re-calculation of face boxes when image loads
                          if (imageBox) {
                            setImageBoxWidth(imageBox.offsetWidth);
                            setImageBoxHeight(imageBox.offsetHeight);
                          }
                        }}
                      />
                      {face_postions.length > 0
                        ? face_postions.map((item, index) =>
                            faceBox(index, item)
                          )
                        : ""}
                    </div>
                  </div>
                </div>
                {face_postions.length > 1 && (
                  <div className="face-selection-info mt-3">
                    <div className="info-card p-3 bg-light rounded">
                      <div className="d-flex align-items-center">
                        <i className="fa fa-info-circle text-primary me-2"></i>
                        <div>
                          <strong>Multiple faces detected!</strong>
                          <br />
                          <small className="text-muted">
                            Face {facekey + 1} of {face_postions.length} selected. Click on a different face to change selection.
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-left-actions">
                <div className="action-buttons-container">
                  <button
                    type="button"
                    className="btn btn-secondary btn-prev"
                    onClick={() => setStep(0)}
                  >
                    <i className="fa fa-arrow-left me-1"></i>
                    Back
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-next"
                    onClick={() => cropTemplate()}
                  >
                    Next
                    <i className="fa fa-arrow-right ms-1"></i>
                  </button>
                </div>
                {errormessage != "" && (
                  <div className="alert alert-danger alert-dismissible mt-3">
                    <span
                      className="close"
                      onClick={() => setErrormessage("")}
                    >
                      &times;
                    </span>
                    {errormessage}
                  </div>
                )}
              </div>
            </div>
          ) : (step == 2) ? ( // Select image type
            <div className="image-type-selection-wrapper" style={{flex: "1", maxWidth: "100%"}}>
              <div className="image-selection-container">
                <div className="text-center mb-4">
                  <h5 className="selection-title">Choose Your Animation Style</h5>
                  <p className="text-muted small mb-0">
                    Select how your face animation should be framed. Only the head will be animated in both options.
                  </p>
                </div>
                <div className="image-selection-grid">
                  <div className="image-selection-card" onClick={() => selectImageType('cropped')}>
                    <div className="card-image-container">
                      {cropped_source_url ? (
                        <img
                          src={cropped_source_url}
                          alt="Cropped face preview"
                          className="preview-image"
                        />
                      ) : (
                        <div className="image-placeholder">
                          <i className="fa fa-user-circle"></i>
                        </div>
                      )}
                    </div>
                    <div className="card-content">
                      <h6 className="card-title">
                        <i className="fa fa-crop-alt me-2"></i>
                        Cropped Face
                      </h6>
                      <p className="card-description">
                        Close-up head animation with optimal detail
                      </p>
                      <div className="card-benefits">
                        <span className="benefit-tag benefit-success">
                          <i className="fa fa-eye me-1"></i>
                          Best Quality
                        </span>
                        <span className="benefit-tag benefit-success">
                          <i className="fa fa-check me-1"></i>
                          Always Works
                        </span>
                      </div>
                    </div>
                    <button type="button" className="selection-button">
                      <i className="fa fa-check me-1"></i>
                      Use Cropped Face
                    </button>
                  </div>

                  <div
                    className={`image-selection-card ${face_postions.length > 1 ? 'disabled' : ''}`}
                    onClick={() => face_postions.length === 1 && selectImageType('resized')}
                    style={face_postions.length > 1 ? { cursor: 'not-allowed', opacity: 0.6 } : {}}
                  >
                    {face_postions.length > 1 && (
                      <div className="disabled-overlay">
                        <div className="disabled-content">
                          <i className="fa fa-lock fa-2x mb-2"></i>
                          <p className="mb-0">
                            <strong>Not available</strong>
                          </p>
                          <small>Multiple faces detected. Only one face can be in the final image.</small>
                        </div>
                      </div>
                    )}
                    <div className="card-image-container">
                      {resized_source_url ? (
                        <img
                          src={resized_source_url}
                          alt="Full image preview"
                          className="preview-image"
                        />
                      ) : (
                        <div className="image-placeholder">
                          <i className="fa fa-image"></i>
                        </div>
                      )}
                    </div>
                    <div className="card-content">
                      <h6 className="card-title">
                        <i className="fa fa-expand-arrows-alt me-2"></i>
                        Full Image
                      </h6>
                      <p className="card-description">
                        More realistic with background context
                      </p>
                      <div className="card-benefits">
                        <span className="benefit-tag benefit-success">
                          <i className="fa fa-layer-group me-1"></i>
                          More Context
                        </span>
                        <span className="benefit-tag benefit-warning">
                          <i className="fa fa-exclamation-triangle me-1"></i>
                          Can't Handle Long Hair
                        </span>
                      </div>
                    </div>
                    <button type="button" className="selection-button" disabled={face_postions.length > 1}>
                      <i className="fa fa-check me-1"></i>
                      Use Full Image
                    </button>
                  </div>
                </div>
              </div>

              <div className="image-selection-actions mt-4">
                <div className="action-buttons-container">
                  <button
                    type="button"
                    className="btn btn-secondary btn-prev"
                    onClick={() => setStep(1)}
                  >
                    <i className="fa fa-arrow-left me-1"></i>
                    Back
                  </button>
                </div>
              </div>

              {errormessage != "" && (
                <div className="alert alert-danger alert-dismissible mt-3">
                  <span
                    className="close"
                    onClick={() => setErrormessage("")}
                  >
                    &times;
                  </span>
                  {errormessage}
                </div>
              )}
            </div>
          ) : (step == 3) && ( // Voice recording step
            <div style={{ flex: "1", maxWidth: "100%" }}>
              <VoiceRecorder
                isEnabled={useVoiceMorphing}
                onToggleEnable={setUseVoiceMorphing}
                onRecordingComplete={handleVoiceRecordingComplete}
                onError={handleVoiceRecordingError}
              />

              <div className="voice-step-actions mt-4">
                <div className="action-buttons-container">
                  <button
                    type="button"
                    className="btn btn-secondary btn-prev"
                    onClick={() => setStep(2)}
                  >
                    <i className="fa fa-arrow-left me-1"></i>
                    Back
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-next"
                    onClick={proceedToFinalStep}
                    disabled={useVoiceMorphing && !audioBlob}
                  >
                    {useVoiceMorphing && audioBlob ? (
                      <>
                        <i className="fa fa-microphone me-1"></i>
                        Create with Voice
                      </>
                    ) : (
                      <>
                        Continue
                        <i className="fa fa-arrow-right ms-1"></i>
                      </>
                    )}
                  </button>
                </div>
              </div>

              {errormessage != "" && (
                <div className="alert alert-danger alert-dismissible mt-3">
                  <span
                    className="close"
                    onClick={() => setErrormessage("")}
                  >
                    &times;
                  </span>
                  {errormessage}
                </div>
              )}
            </div>
          )}

          {/* RIGHT COLUMN: showing progress */}
          { step < 4 && (
            <div className="uploading-block-right mt-4 mt-sm-0">
              <div className="steps-container">
                <h5 className="upload-step-title">
                  <i className="fa fa-list-ol me-2"></i>
                  Progress
                </h5>
                <div className="upload-step-list">
                  <div className={`upload-step ${step > 0 ? "completed" : "active"}`}>
                    <div className="step-icon">
                      {step > 0 ? (
                        <i className="fa fa-check"></i>
                      ) : (
                        <span className="step-number">1</span>
                      )}
                    </div>
                    <div className="step-content">
                      <span className="step-title">Upload Image</span>
                      <span className="step-description">Choose a clear photo</span>
                    </div>
                  </div>

                  <div className={`upload-step ${
                    step > 1 ?
                      "completed"
                    : step == 1 ?
                      "active"
                    :
                      "pending"
                  }`}>
                    <div className="step-icon">
                      {step > 1 ? (
                        <i className="fa fa-check"></i>
                      ) : step == 1 ? (
                        <span className="step-number">2</span>
                      ) : (
                        <span className="step-number">2</span>
                      )}
                    </div>
                    <div className="step-content">
                      <span className="step-title">Select Face</span>
                      <span className="step-description">Choose the face to animate</span>
                    </div>
                  </div>

                  <div className={`upload-step ${
                    step > 2 ?
                      "completed"
                    : step == 2 ?
                      "active"
                    :
                      "pending"
                  }`}>
                    <div className="step-icon">
                      {step > 2 ? (
                        <i className="fa fa-check"></i>
                      ) : step == 2 ? (
                        <span className="step-number">3</span>
                      ) : (
                        <span className="step-number">3</span>
                      )}
                    </div>
                    <div className="step-content">
                      <span className="step-title">Choose Style</span>
                      <span className="step-description">Pick animation format</span>
                    </div>
                  </div>

                  <div className={`upload-step ${
                    step > 3 ?
                      "completed"
                    : step == 3 ?
                      "active"
                    :
                      "pending"
                  }`}>
                    <div className="step-icon">
                      {step > 3 ? (
                        <i className="fa fa-check"></i>
                      ) : step == 3 ? (
                        <span className="step-number">4</span>
                      ) : (
                        <span className="step-number">4</span>
                      )}
                    </div>
                    <div className="step-content">
                      <span className="step-title">
                        Voice Morphing
                        <span className="premium-badge">Premium</span>
                      </span>
                      <span className="step-description">Use AI voice</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          </div>
        )}
      </Modal.Body>

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <Modal
          show={showConfirmModal}
          size="sm"
          aria-labelledby="confirm-modal-title"
          className="confirm-modal"
          centered
          onHide={handleConfirmCancel}
          style={{ zIndex: "1000000" }}
          backdrop="static"
        >
          <Modal.Header>
            <Modal.Title id="confirm-modal-title">
              <div className="d-flex align-items-center">
                <i className="fa fa-exclamation-triangle text-warning me-2"></i>
                <span>Unsaved Changes</span>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-3">
              You have unsaved changes to your animation. What would you like to do?
            </p>
            <div className="text-muted small">
              <strong>"{title}"</strong> has not been saved yet.
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={handleConfirmCancel}
            >
              <i className="fa fa-arrow-left me-1"></i>
              Go Back
            </button>
            <div className="d-flex" style={{ gap: "8px" }}>
              <button
                type="button"
                className="btn btn-warning text-white"
                onClick={handleConfirmDiscard}
              >
                <i className="fa fa-trash me-1"></i>
                Discard
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleConfirmSave}
              >
                <i className="fa fa-save me-1"></i>
                Save
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </Modal>
  )
}

export default CreateAnimation
